export const FETCH_PROFILE = 'FETCH_PROFILE';
export const LOGOUT_PROFILE = 'LOGOUT_PROFILE';